import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

const TYPE_STYLE = {
  success: { bg: '#f0fdf4', border: '#86efac', color: '#15803d', icon: '✓' },
  error:   { bg: '#fef2f2', border: '#fca5a5', color: '#dc2626', icon: '✕' },
  info:    { bg: '#eff6ff', border: '#93c5fd', color: '#1d4ed8', icon: 'ℹ' },
  warning: { bg: '#fffbeb', border: '#fde68a', color: '#d97706', icon: '⚠' },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, type = 'info', duration = 3500) => {
    const id = Date.now() + Math.random();
    setToasts(t => [...t, { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), duration);
  }, []);

  const dismiss = useCallback((id) => setToasts(t => t.filter(x => x.id !== id)), []);

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      <div style={{
        position: 'fixed', bottom: 24, right: 24,
        zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8,
        maxWidth: 360, pointerEvents: 'none',
      }}>
        {toasts.map(t => {
          const s = TYPE_STYLE[t.type] || TYPE_STYLE.info;
          return (
            <div key={t.id} style={{
              background: s.bg, border: `1px solid ${s.border}`,
              borderRadius: 10, padding: '12px 16px',
              display: 'flex', alignItems: 'flex-start', gap: 10,
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              pointerEvents: 'auto',
              animation: 'slideIn 0.2s ease',
            }}>
              <span style={{ color: s.color, fontWeight: 700, flexShrink: 0 }}>{s.icon}</span>
              <span style={{ color: s.color, fontSize: 14, flex: 1, lineHeight: 1.5 }}>{t.message}</span>
              <button onClick={() => dismiss(t.id)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: s.color, fontSize: 16, padding: 0, flexShrink: 0, lineHeight: 1 }}>
                ×
              </button>
            </div>
          );
        })}
      </div>
      <style>{`@keyframes slideIn { from { opacity:0; transform:translateY(8px) } to { opacity:1; transform:none } }`}</style>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx.show;
}
